module.exports = __webpack_public_path__ + "img/logo.b9265400.svg";